import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/about.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineFacebook,
 
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={7} className="home-about-description" >
         
          
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
          <br/>
          <br/>
          
            <h2 style={{ fontSize: "2.3em" }}>
             Hi, I am <span className="purple"> Zian </span> 
            </h2>
          <br />
          <br />
            <p className="home-about-body">

            I am a passionate software developer with expertise in building efficient, scalable & user-friendly solutions. Skilled in
            
            <i>
              <b className="purple">HTML, CSS, JavaScript, React, Next.js, & Python.  </b>
            </i>
              I create responsive, high-performance applications that deliver seamless, engaging user experiences across modern web platforms.🤷‍♂️
              <br />
              <br />
              
              My skill set extends beyond the frontend, with a strong command of Python for
              <i>
                <b className="purple"> backend development, automation, & data processing. </b>
              </i> 
              Applying Object-Oriented Programming, I design robust, maintainable, & reusable code, ensuring my projects remain functional, scalable, & sustainable for long-term performance.
              
              <br />
              <br />
              
              I enjoy working on 
              <i>
            <b className="purple">both independent and collaborative projects, where I can combine my technical skills with problem-solving creativity. </b>
          </i>
              I am driven by a continuous desire to learn and stay up-to-date with emerging technologies, 
          
              <br />
              <br />
            </p>
          </Col>
          <Col md={5} style={{ paddingBottom: 50 }}
          className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="myAvatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ZIAN786"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/zakir.zian.7"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/zakir-zian-616187206/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
